module.exports = __webpack_public_path__ + "static/media/IconHomeData.7774df37.svg";